import React, { useEffect } from 'react';
import InfoTooltip from '../tooltips/InfoTooltip';
import CountField from '../fields/CountField';
import {useFormState, useForm} from 'react-final-form';
import {useSelector} from 'react-redux';
import {universalPagesValidation} from '../../helpers/universalPagesValidation';
import useWordsCalculator from '../../hooks/useWordsCalculator';
import useFieldRules from '../../hooks/useFieldRules';
import useSyncedField from '../../hooks/useSyncedField';
import Tooltips from '../../helpers/fieldTooltips';
import QueryStorage from "../../../../../common/helpers/QueryStorage";

function Page() {
    const words = useWordsCalculator('page', 'spacing');
    const {limits} = useSelector(state => state.orderOptions.data);
    const {values} = useFormState();
    const form = useForm();
    const {isVisible} = useFieldRules('page');

    useSyncedField('page', 'int');

    useEffect(() => {
        const pageCount = parseInt(values.page) || 0;
        if (pageCount === 0) {
            form.batch(() => {
                form.change('plagiarismReport', 0);
                form.change('authorCategory', 'Regular');
                form.change('abstractPage', 0);
                form.change('editorCheck', 0);

                QueryStorage.set("plagiarismReport", 0);
                QueryStorage.set("authorCategory", "Regular");
                QueryStorage.set("abstractPage", 0);
                QueryStorage.set("editorCheck", 0);
            });
        }
    }, [values.page, form]);

    if (!isVisible) return null;

    return (
        <div className="form-group form-control-pages">
            <div className="form-label d-flex">
                {limits && limits.page ? limits.page.label : ''}
                {values && values.page > 1 ? 's' : ''}
                <InfoTooltip>
                    <p>{Tooltips.page}</p>
                </InfoTooltip>
            </div>
            <div className="calculator-pages">
                <CountField
                    name="page"
                    validate={universalPagesValidation('page')}
                />
                <span className="calculator-pages__info">
                    {parseFloat(words).toLocaleString('en-US')} words
                </span>
            </div>
        </div>
    );
}

export default Page;
